import { render } from "./ModalCancelarSuscripcionOnboarding.vue?vue&type=template&id=e417b79a&scoped=true&ts=true"
import script from "./ModalCancelarSuscripcionOnboarding.vue?vue&type=script&lang=ts"
export * from "./ModalCancelarSuscripcionOnboarding.vue?vue&type=script&lang=ts"

import "./ModalCancelarSuscripcionOnboarding.vue?vue&type=style&index=0&id=e417b79a&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e417b79a"]])

export default __exports__